import { faArrowsAltV, faBookOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'
import { Button } from 'reactstrap'
import Select from 'views/pages/Group/Select'

const BreadCrumb = (props) => {
  let language = props.language || {}
  const history = useHistory()
  return (
    <div className='breadcrumb-wrapper'>
      {props.library.filesParents &&
      props.library.filesParents.length >= 0 &&
      props.library.parentId ? (
        <span
          style={{
            marginRight: '15px',
          }}
        >
          <a //eslint-disable-line
            title={
              language.my_library ? language.my_library.back_to_library : null
            }
            onClick={() => history.push('/library')}
            className='root-link text-dark'
          >
            <FontAwesomeIcon icon={faBookOpen} />
          </a>
          <a //eslint-disable-line
            title={
              language.my_library ? language.my_library.back_to_library : null
            }
            onClick={() => history.push('/library')}
            className='back-library-label h4 text-dark'
          >
            {language.my_library ? language.my_library.back_to_library : null}
          </a>
        </span>
      ) : null}
      {props.library.filesParents && props.library.filesParents.length
        ? props.library.filesParents.map((item, index) => (
            <span
              key={index}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
            >
              <span className='divider'> / </span>
              <span
                onClick={() => history.push('/library/folder/' + item.id)}
                title={item.name}
                className='bc-link'
              >
                {item.name}
              </span>
            </span>
          ))
        : null}
      {props.library.parent ? (
        <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
          <span className='divider'> / </span>
          <span className='divider-label'>{props.library.parent.name}</span>
        </span>
      ) : null}
    </div>
  )
}

export default BreadCrumb
